// import React from "react";
// import { useLocation, Route, Switch, Redirect } from "react-router-dom";
// // reactstrap components
// import { Container } from "reactstrap";
// // core components
// import AdminNavbar from "components/Navbars/AdminNavbar.js";
// import AdminFooter from "components/Footers/AdminFooter.js";
// import Sidebar from "components/Sidebar/Sidebar.js";

// import routes from "routes.js";

// const Admin = (props) => {
//   const mainContent = React.useRef(null);
//   const location = useLocation();
//   const [isLogedin, setIsLogedin] = React.useState(false);
//   React.useEffect(() => {
//     const token = sessionStorage.getItem("Authtoken");
//     if (token == null) {
//       setIsLogedin(true);
//     }
//   }, []);
//   React.useEffect(() => {
//     document.documentElement.scrollTop = 0;
//     document.scrollingElement.scrollTop = 0;
//     mainContent.current.scrollTop = 0;
//   }, [location]);

//   const getRoutes = (routes) => {
//     return routes.map((prop, key) => {
//       if (prop.layout === "/admin") {
//         return <Route path={prop.layout + prop.path} component={prop.component} key={key} />;
//       } else if (prop.collapse) {
//         return prop.views.map((item, key) => (
//           <Route path={item.layout + item.path} component={item.component} key={key} />
//         ));
//       } else {
//         return null;
//       }
//     });
//   };

//   const getBrandText = (path) => {
//     for (let i = 0; i < routes.length; i++) {
//       if (props.location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
//         return routes[i].name;
//       }
//     }
//     return "Brand";
//   };
//   if (isLogedin) {
//     return <Redirect to="/auth/login" />;
//   }
//   return (
//     <>
//       <Sidebar
//         {...props}
//         routes={routes}
//         logo={{
//           innerLink: "/admin/index",
//           imgSrc: require("../assets/img/brand/logo.png").default,
//           imgAlt: "...",
//         }}
//       />
//       <div className="main-content" ref={mainContent}>
//         <AdminNavbar {...props} brandText={getBrandText(props.location.pathname)} />
//         <Switch>
//           {getRoutes(routes)}
//           <Redirect from="*" to="/admin/index" />
//         </Switch>
//         <Container fluid>
//           <AdminFooter />
//         </Container>
//       </div>
//     </>
//   );
// };

// export default Admin;

















import React from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
import { io } from "socket.io-client";
import { Container } from "reactstrap";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "routes.js";

const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const [isLogedin, setIsLogedin] = React.useState(false);

  // ✅ Socket.IO listener - other device logout
  React.useEffect(() => {
    const token = sessionStorage.getItem("Authtoken");
    const adminId = sessionStorage.getItem("current_user_id");

    if (!token || !adminId) {
      console.log("[Admin Socket] No token/adminId found");
      return;
    }

    console.log("[Admin Socket] Setting up socket listener...");
    console.log("[Admin Socket] Token:", token.slice(0, 20) + "...");
    console.log("[Admin Socket] AdminId:", adminId);

    const socket = io("https://shoperschoiceapi.theshoperschoice.com", {
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5,
    });

    socket.on("connect", () => {
      console.log("[Admin Socket] Connected! Socket ID:", socket.id);
      socket.emit("authenticate", token);
      console.log("[Admin Socket] Authenticated");
    });

    socket.on("connect_error", (err) => {
      console.error("[Admin Socket] Connection error:", err.message);
    });

    // ✅ forceLogout event - other device/browser se logout
    socket.on("forceLogout", (data) => {
      console.log("[Admin Socket] 🚨 forceLogout event received:", data);

      // ✅ Storage clear
      sessionStorage.clear();
      localStorage.clear();

      // ✅ Alert user
      alert(data?.message || "You have been logged out from another device");

      // ✅ Redirect to login
      console.log("[Admin Socket] Redirecting to login...");
      window.location.href = "/auth/login";
    });

    socket.on("disconnect", () => {
      console.log("[Admin Socket] Disconnected");
    });

    return () => {
      console.log("[Admin Socket] Cleaning up socket...");
      socket.disconnect();
    };
  }, []); // Empty dependency - sirf ek baar mount pe

  // ✅ Token check - login check
  React.useEffect(() => {
    const token = sessionStorage.getItem("Authtoken");
    if (token == null) {
      setIsLogedin(true);
    }
  }, []);

  // ✅ Scroll to top
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else if (prop.collapse) {
        return prop.views.map((item, key) => (
          <Route
            path={item.layout + item.path}
            component={item.component}
            key={key}
          />
        ));
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props.location.pathname.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  if (isLogedin) {
    return <Redirect to="/auth/login" />;
  }

  return (
    <>
      <Sidebar
        {...props}
        routes={routes}
        logo={{
          innerLink: "/admin/index",
          imgSrc: require("../assets/img/brand/logo.png").default,
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props.location.pathname)}
        />
        <Switch>
          {getRoutes(routes)}
          <Redirect from="*" to="/admin/index" />
        </Switch>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default Admin;
